import React from 'react';
import './style.scss';
import ColombiaForm from './co-form';
import ArgentinaForm from './ar-form';

export default class Success extends React.Component<any> {
  constructor(props) {
    super(props);
  }
  render() {
    const { country } = this.props;
    switch (country) {
      case 'AR':
        return <ArgentinaForm {...this.props} />;
      case 'CO':
        return <ColombiaForm {...this.props} />;
    }
  }
}
